import { AssignmentMode } from "./priceFormat-types";
export const getAssignmentMode = (configObject) => {
    if (!configObject) {
        return AssignmentMode.NO_CONFIG;
    }
    else if ((configObject === null || configObject === void 0 ? void 0 : configObject["RecipeSelectionType"]) === 10 || (configObject === null || configObject === void 0 ? void 0 : configObject["MealQuantitySelectionMode"]) === 10) {
        return AssignmentMode.ASSIGN_RECIPES;
    }
    else if ((configObject === null || configObject === void 0 ? void 0 : configObject["RecipeSelectionType"]) === 0 || (configObject === null || configObject === void 0 ? void 0 : configObject["MealQuantitySelectionMode"]) === 20) {
        return AssignmentMode.ADD_MEALS;
    }
    else if ((configObject === null || configObject === void 0 ? void 0 : configObject["RecipeSelectionType"]) === 20) {
        return AssignmentMode.BOTH;
    }
    else
        return AssignmentMode.NO_CHANGES;
};
// RecipeSelectionType {
//   AddMeals = 0,
//   AssignRecipes = 10,
//   Both = 20, // only the recipe module has a both option
//   None = 30,
// }
// MyMealsQuantitySelectionMode {
//   NoChanges = 0, // no changes
//   DiscreteChanges = 10, // assign recipes
//   AdHocChanges = 20, // add meals
// }
